
const pages = [
  {
    title: "Home",
  },
  {
    title: "About us",
  },
  {
    title: "Products",
  },
  {
    title: "Services",
  },
  {
    title: "Location",
  },
  {
    title: "Contacts",
  },
 
];

export default pages;
